import { render, staticRenderFns } from "./EditRoccSeverity.vue?vue&type=template&id=55ef2cbf&"
import script from "./EditRoccSeverity.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EditRoccSeverity.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports